import React, { useEffect } from "react";
import Styled from "styled-components";
import Sapimg from "../Images/SAPImage.png";
import lie from "../Images/lie.jpg";
export default function Sap() {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  return (
    <DIV>
      <BOX>
        <h1>Summer School Internships</h1>

        <COLOR>
          <TOP>
            <p className="above">
              The Centre offers two months internship opportunity wherein the
              students can engage in full time research on various topics of
              interdisciplinary character connecting science and law. The
              research must discuss major ethical dilemmas pertaining to the
              area under study.
            </p>
            <H4>Who can apply?</H4>

            <p className="below">
              Graduate and Post Graduate students from recognized institutions
              and Universities (from India as well as Abroad) from the
              discipline of science and law can apply. The admission to the
              program will be based on merit. Applications to the internship
              program will be invited from time to time by the Centre. The
              notification will be issued in this page as well as on the website
              of the University.
            </p>
          </TOP>
        </COLOR>
      </BOX>
    </DIV>
  );
}
const H3 = Styled.h3`
    font-family: PT Serif;
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 26px;
    color: #000000;
    @media (max-width:640px){
      font-size: 18px;
    }
    @media (max-width:540px){
      font-size: 16px;
    }
    @media (max-width:395px){
      font-size: 14px;
    }
   `;
const H4 = Styled.h4`
   font-family: PT Serif;
   font-style: normal;
   font-weight: normal;
   font-size: 20px;
   line-height: 16px;
   color:#8585e7;
   @media (max-width:640px){
    font-size: 18px;
  }
  @media (max-width:540px){
    font-size: 16px;
  }
  @media (max-width:395px){
    font-size: 14px;
  }`;
const DIV = Styled.div`

background: #FAFAFA;
display:flex ;
justify-content:center;
align-items: center;
width:100%;
`;

const BOX = Styled.div`

width:85%;
margin:50px auto;
h1{
  font-family: Oswald;
  font-style: normal;
  font-weight: normal;
  font-size: 32px;
  line-height: 36px;
  font-weight:500;
  color: #E01E38;
  display:flex;
 }
 @media (max-width:1132px){
 h1{
  font-size: 32px;
  }
}
@media (max-width:1065px){
  h1{
   font-size: 31px;
   }
 }
 @media (max-width:534px){
  h1{
   font-size: 28px;
   }
 }
 @media (max-width:395px){
  padding: 16px;
  h1{
   font-size: 26px;
   }
 }
li{
    margin-left:50px;
    text-align:justify;
    font-size:20px;
    line-height:24px;
    font-family: PT Serif;
   
}
@media (max-width:640px){
   li{
    font-size:18px;
   }
}
@media (max-width:534px){
  li{
    font-size:16px;
  }
 }
 @media (max-width:395px){
  li{
    font-size:14px;
  }
 }
`;
const COLOR = Styled.div`
background:white;
padding:20px 40px;
box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.25);
`;

const TOP = Styled.div`
@media (max-width:530px){
  display:flex;
  flex-direction:column;
  align-items:center;
}
 p.above{
    font-family: PT Serif;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 24px;
    color: #000000;
    text-align:justify;
    @media (max-width:640px){
      font-size: 18px;
    }
    @media (max-width:540px){
      font-size: 16px;
    }
  }
 p.below{
    font-family: PT Serif;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 24px;
    color: #000000;
    text-align:justify;
    @media (max-width:640px){
      font-size: 18px;
    }
    @media (max-width:540px){
      font-size: 16px;
    }
 }


`;
